/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicGoalMilestone', 'model/StrategicGoalMilestoneReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategicGoalMilestone'), require('../model/StrategicGoalMilestoneReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicGoalMilestoneApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicGoalMilestone, root.ForStractionServiceApi.StrategicGoalMilestoneReport);
  }
}(this, function(ApiClient, StrategicGoalMilestone, StrategicGoalMilestoneReport) {
  'use strict';

  /**
   * StrategicGoalMilestone service.
   * @module api/StrategicGoalMilestoneApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategicGoalMilestoneApi. 
   * @alias module:api/StrategicGoalMilestoneApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategicGoalMilestoneAddAllPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicGoalMilestone>} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.strategicGoalMilestoneAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneAddPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategicGoalMilestoneAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneArchivePut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneArchivePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * archive
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneArchivePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneReport}
     */
    this.strategicGoalMilestoneArchivePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneArchivePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneArchivePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneReport;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/archive', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneCompletePut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneCompletePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * complete
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneCompletePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneCompletePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneCompletePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneCompletePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/complete', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneDeleteGet operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling strategicGoalMilestoneDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneEditAllPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicGoalMilestone>} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneEditAndUpdateProgressPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditAndUpdateProgressPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAndUpdateProgress
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditAndUpdateProgressPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneReport}
     */
    this.strategicGoalMilestoneEditAndUpdateProgressPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneEditAndUpdateProgressPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneEditAndUpdateProgressPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneReport;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/editAndUpdateProgress', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneEditPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneLoadAllGet operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicGoalMilestoneReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxMetricsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {Integer} opts.includeDataActuals  (default to 0)
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicGoalMilestoneReport>}
     */
    this.strategicGoalMilestoneLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxMetricsCount': opts['maxMetricsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount'],
        'includeDataActuals': opts['includeDataActuals']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicGoalMilestoneReport];

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneLoadGet operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxMetricsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneReport}
     */
    this.strategicGoalMilestoneLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling strategicGoalMilestoneLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxMetricsCount': opts['maxMetricsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneReport;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneLoadManyPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadManyPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicGoalMilestoneReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMany
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxMetricsCount  (default to 0)
     * @param {Integer} opts.maxStatusUpdatesCount  (default to 0)
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneLoadManyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicGoalMilestoneReport>}
     */
    this.strategicGoalMilestoneLoadManyPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneLoadManyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneLoadManyPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxMetricsCount': opts['maxMetricsCount'],
        'maxStatusUpdatesCount': opts['maxStatusUpdatesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicGoalMilestoneReport];

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/loadMany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestonePublishAndSendNotificationsPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestonePublishAndSendNotificationsPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * publishAndSendNotifications
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestone} body 
     * @param {String} messageFromUser 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestonePublishAndSendNotificationsPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneReport}
     */
    this.strategicGoalMilestonePublishAndSendNotificationsPut = function(_4SAPIAppID, body, messageFromUser, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestonePublishAndSendNotificationsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestonePublishAndSendNotificationsPut";
      }

      // verify the required parameter 'messageFromUser' is set
      if (messageFromUser == undefined || messageFromUser == null) {
        throw "Missing the required parameter 'messageFromUser' when calling strategicGoalMilestonePublishAndSendNotificationsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'messageFromUser': messageFromUser
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneReport;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/publishAndSendNotifications', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneSendUpdateRequestNotificationPut operation.
     * @callback module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneSendUpdateRequestNotificationPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendUpdateRequestNotification
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {String} coverLetter 
     * @param {module:api/StrategicGoalMilestoneApi~strategicGoalMilestoneSendUpdateRequestNotificationPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneSendUpdateRequestNotificationPut = function(_4SAPIAppID, body, coverLetter, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneSendUpdateRequestNotificationPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneSendUpdateRequestNotificationPut";
      }

      // verify the required parameter 'coverLetter' is set
      if (coverLetter == undefined || coverLetter == null) {
        throw "Missing the required parameter 'coverLetter' when calling strategicGoalMilestoneSendUpdateRequestNotificationPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'coverLetter': coverLetter
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestone/sendUpdateRequestNotification', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
